import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import styled from 'styled-components';
import { Text } from './Boneyard';

const StyledFieldError = styled(Text)`
  color: ${props => props?.theme.colors.common.form.required};
  font-style: italic;
  font-size: 12px;
`;

const propTypes = {
  fieldName: PropTypes.string,
  errorMessage: PropTypes.string,
};

const FieldErrorMessage = ({ fieldName, errorMessage }) => {
  return (
    <StyledFieldError>
      {errorMessage ? (
        <span>{errorMessage}</span>
      ) : (
        <ErrorMessage name={fieldName} />
      )}
    </StyledFieldError>
  );
};

FieldErrorMessage.propTypes = propTypes;
export default FieldErrorMessage;
